module.exports = __webpack_public_path__ + "img/win_3.77b50c86.png";